import { getOutlookInstance, SessionId, HxAccount } from '@outlook/hxcore_web';
import { isPieNamespaceGTE } from 'owa-client-pie';
import { refreshAuthToken } from 'owa-client-pie/lib/authentication.g';
import {
    handleAccessTokenUpdateEvent,
    AccessTokenUpdateEventData,
} from 'hx-account-events/lib/webviewAccountEvents';
import { isBootFeatureEnabled } from 'owa-metatags';
import { handleHxObjectLoadResult } from 'hx-object-load-helpers';

async function refreshAccountUsingPie(account: HxAccount) {
    const response = await refreshAuthToken(
        account.emailAddress,
        account.syncSettings_WebAccountId
    );

    const updateEvent = {
        eventType: 'AccessTokenUpdate',
        source: 'AccountUtil',
        email: account.emailAddress,
        accessToken: response.accessToken,
        expiresDur: response.expiresDur,
    };

    const outlookInstance = getOutlookInstance();
    const sessionId = outlookInstance.activeSet.createSession();
    try {
        await handleAccessTokenUpdateEvent(updateEvent as AccessTokenUpdateEventData, sessionId);
    } finally {
        outlookInstance.activeSet.releaseSession(sessionId);
    }
}

export async function refreshAllAccountAuthTokens(sessionId: SessionId) {
    const hx = getOutlookInstance();
    const root = await hx.activeSet.getRoot(sessionId);
    const accounts = handleHxObjectLoadResult(
        await root.getAccountsSyncingMailOrCalendar(sessionId)
    );
    const usePie =
        isBootFeatureEnabled('pieauth') && (await isPieNamespaceGTE('Authentication', 0.2));
    accounts.items.forEach(account => {
        if (usePie) {
            refreshAccountUsingPie(account);
        } else {
            let msg = {
                source: 'AccountUtil',
                action: 'RefreshAuthTokenRequest',
                args: {
                    email: account.emailAddress,
                    webAccountId: account.syncSettings_WebAccountId,
                },
            };

            window.chrome!.webview!.postMessage(msg);
        }
    });
}
